import { useEffect, useState } from "react";
import AutocompletePaginado from "./AutocompletePaginado";
import '../App.css';
import Button from '@mui/material/Button';
import { Pagination, Tooltip } from "@mui/material";
import Input from "./Input";
import InputMonetary from "./InputMonetary";
import Loading from "./Loading";
import CloudOffIcon from '@mui/icons-material/CloudOff';

const classNames = {
    "autocomplete": "autocomplete",
    "button": "action-button",
    "decimal": "decimal",
    "delete-button": "delete-button",
    "usuarios-admin-delete-button": "usuarios-admin-delete-button",
    "contract-status": "contract-status",
    "status-badge": "status-badge"
};

const Table = ({ params, dataArray = [], pageData, filter = '', refreshKey = '', loading = {loading: false}, errorOccurred }) => {
    const [page, setPage] = useState(1); // Página atual
    const [rowsPerPage] = useState(10); // Tamanho da página

    const totalPages = pageData?.totalPages;

    useEffect(() => { setPage(1) }, [filter])

    const calculateTotals = () => {
        return params.columns.map((param) => {
            if (param.type === "input-decimal" && param.showTotalValueFooter) {
                return dataArray.reduce((sum, item) => sum + (parseFloat(item[param.key]) || 0), 0);
            }
            return null;
        });
    };

    const totals = calculateTotals();

    const renderFooterCells = () => {
        const footerColumns = params.columns.map((param, index) => ({ param, index }));
        const configuredFooters = footerColumns.filter(({ param }) => param.htmlFooter && param.footer);
        const cells = [];

        for (let index = 0; index < params.columns.length;) {
            const configuredFooter = configuredFooters.find(({ param }) => param.footer.startColumn === index);

            if (configuredFooter) {
                const { param } = configuredFooter;
                const colSpan = Math.min(Math.max(param.footer.colSpan || 1, 1), params.columns.length - index);

                cells.push(
                    <td key={index} colSpan={colSpan} className={classNames[param.css]} style={{ alignContent: 'left' }}>
                        {param.htmlFooter()}
                    </td>
                );
                index += colSpan;
                continue;
            }

            const param = params.columns[index];
            cells.push(
                <td key={index} className={classNames[param.css]} style={{ alignContent: 'left' }}>
                    {param.type === "input-decimal" && param.showTotalValueFooter
                        ? <strong>{'R$ ' + totals[index]?.toFixed(2)}</strong>
                        : (!param.footer && param.htmlFooter && param.htmlFooter())}
                </td>
            );
            index += 1;
        }

        return cells;
    };

    if (loading?.loading) return <Loading text={loading.text}></Loading>;

    if (errorOccurred && Object.keys(errorOccurred).length > 0) {
        return <div className="mensagem-erro">
            <CloudOffIcon className="icone-erro" />

            <h2>Ocorreu um erro ao carregar os dados</h2>

            <p>
                Não foi possível buscar as informações no momento.
                Tente novamente em instantes.
            </p>

            {/* {onRetry && (
        <Button variant="contained" onClick={onRetry}>
          Tentar novamente
        </Button>
      )} */}
        </div>
    }

    if (dataArray.length <= 0) {
        return <div className="mensagem-vazia">
            <h2>Nenhum resultado encontrado</h2>
            <p>Verifique os filtros e tente novamente.</p>
        </div>
    }

    return (
        <div className={`item-table ${params.containerClassName || ''}`}>
            <table key={refreshKey} >
                <thead>
                    <tr >
                        {params.columns.map((param, index) => (
                            <th key={index} className={classNames[param.css]}>
                                {param.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dataArray.map((item, rowIndex) => (
                        <tr key={rowIndex}>
                            {params.columns.map((param, colIndex) => (
                                <td className={classNames[param.css]}
                                    key={colIndex}
                                    style={{ width: param.width || 'auto' }}
                                >
                                    {renderCell(param, item)}
                                </td>
                            ))}
                        </tr>

                    ))}
                </tbody>

                {dataArray?.length > 1 && params.hasFooter &&
                    <tfoot>
                        <tr>
                            {renderFooterCells()}
                        </tr>
                    </tfoot>

                }
            </table>



            {pageData && (
                <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                    <Pagination
                        count={pageData.totalPages}
                        page={page}
                        onChange={(event, newPage) => {
                            setPage(newPage);
                            if (params.query) {
                                params.query(newPage - 1); // só chama se for paginado
                            }
                        }}
                    />
                </div>
            )}




        </div>
    );
};

function isDisabled(param, item) {
    return (param.disabled != undefined && (param.disabled instanceof Function ? param.disabled(item) : param.disabled));
}

/**
 * Renderiza o conteúdo de uma célula baseado no tipo
 * @param {Object} param - Parâmetro de configuração da célula
 * @param {Object} item - Dados da linha atual
 */
const renderCell = (param, item) => {
    switch (param.type) {
        case "autocomplete":
            return (
                <AutocompletePaginado
                    endpoint={param.component.endpoint}
                    parameters={{
                        ...param.component.parameters,
                        // bodyToSearch: param.component.parameters.bodyToSearch,
                        // width: param.component.parameters.width,
                        // getLabel: param.component.parameters.getLabel,
                        // disabled: param.component.parameters.disabled,
                        onChange: (selecionado) => param.component.parameters.onChange(item, selecionado),
                        value: (item?.id && param.component.parameters.getValue) ? param.component.parameters.getValue(item) : null,
                        getValue: () => param.component.parameters.getValue(item),
                        // GET: param.component.parameters.GET,
                        // inputStyle: param.component.parameters.inputStyle,
                        id: item?.id
                    }}
                    onChange={(value) => param.onChange(item, value)}
                />
            );
        case "input-number":
            return (
                <input
                    type="number"
                    // {...param}
                    className={classNames[param.css]}
                    disabled={param.disabled || false}
                    value={item[param.key] || ""}
                    onChange={(e) => param.onChange(item, e.target.value)}
                />
            );
        case "input-decimal":
            return (
                <InputMonetary
                    width={param.widthValue || '100%'}
                    value={item[param.key]}
                    disabled={isDisabled(param, item)}
                    onChange={(value) => param.onChange(item, value)}
                />
            );
        case "date":
            // return (<DatePicker disabled={true} value={new Date(item[param.key])} />);

            return <Input value={item[param.key]}

                parameters={{ width: (param.widthValue || '100%'), type: 'date', disabled: isDisabled(param, item), onChange: (value) => { param.onChange(item, value) } }} />

        case "button-icon":
            return (
                <Tooltip title={param.title || ''}>
                    <span>
                        <Button
                            variant="text"
                            title={param.title}
                            aria-label={param.title}
                            disabled={isDisabled(param, item)}
                            style={{ ...param?.style, color: param?.color && (param.color instanceof Function ? param.color(item) : param.color) || '#0057a3' }}
                            onClick={() => param.onClick(item)}
                            startIcon={param.icon}
                        />
                    </span>
                </Tooltip>
            );

        case "checkbox":
            return (<div className="checkbox-group">
                <input type="checkbox"
                    id={param.key}
                    name={param.key}
                    disabled={param.disabled || false}
                    checked={param.getValue(item)}
                    onClick={() => param.onClick(item)}
                />
            </div>)
        default:
            return (
                <input
                    type="text"
                    disabled={true}
                    style={param.style && param.style instanceof Function ? param.style(item) : param.style}
                    value={param.getValue ? param.getValue(item) : item[param.key]}
                />
            );
    }
};


export default Table;
